/**
 * Codifica delle cariche (ADR 0124): i codici carica del Registro delle imprese (tabella delle cariche e qualifiche di
 * InfoCamere, quella delle visure), senza le voci che non sono una carica («888», i poteri 99x, le «nomina a…» C01–C34,
 * dimissionario, receduto, le righe doppie). Ogni carica registrata ha uno di questi codici; le parole della fonte
 * restano come carica scritta.
 */
export const OFFICE_CODES = {
  ACP: 'Amministratore con postilla',
  ACR: 'Amministratore con requisiti',
  ADP: 'Amministratore delegato e preposto',
  AF: 'Affittuario o conduttore',
  AFF: 'Affittuario',
  ALR: 'Ausiliario nominato art.25 sexies dlgs 14/2019',
  AMD: 'Amministratore delegato',
  AMG: 'Amministratore giudiziario',
  AMM: 'Amministratore',
  AMP: 'Amministratore provvisorio',
  AMS: 'Amministratore straordinario',
  APR: 'Amministratore e preposto',
  ART: 'Amministratore e responsabile tecnico',
  ASO: "Socio dell'impresa artigiana",
  ATI: "Titolare dell'impresa artigiana",
  AUN: 'Amministratore unico',
  AUP: 'Amministratore unico e preposto',
  CA: 'Condirettore amministrativo',
  CAD: 'Capo delegazione',
  CAG: 'Capo agenzia',
  CC: 'Condirettore centrale',
  CCG: 'Comitato di controllo gestione',
  CD: 'Condirettore',
  CDG: 'Consigliere e direttore generale',
  CDP: 'Consigliere delegato e preposto',
  CDS: 'Consigliere di sorveglianza',
  CDT: 'Consigliere delegato e responsabile tecnico',
  CE: 'Condirettore commerciale',
  CEP: 'Consigliere e preposto',
  CES: 'Collaboratore esterno',
  CF: 'Condirettore di filiale',
  CG: 'Condirettore generale',
  CGE: 'Consigliere di gestione',
  CGS: 'Consiglio di gestione',
  CI: 'Condirettore interinale',
  CLD: 'Collaudatore',
  CLR: 'Consigliere e legale rappresentante',
  CLT: 'Coltivatore diretto',
  CM: 'Commissario ministeriale',
  CMS: 'Commissario straordinario',
  CNG: 'Coniuge',
  COA: 'Coamministratore',
  COD: 'Consigliere delegato',
  COE: 'Coerede',
  COF: 'Collaboratore familiare',
  COG: 'Commissario giudiziario',
  COL: 'Commissario liquidatore',
  COM: 'Socio',
  CON: 'Consigliere',
  COO: 'Consigliere onorario',
  COP: 'Commissario prefettizio',
  COS: 'Consigliere segretario',
  COT: 'Conduttore',
  COV: 'Commissario governativo',
  COZ: 'Commissario giudiziale',
  CPC: 'Capocantiere',
  CPR: 'Socio comproprietario',
  CRT: 'Curatore',
  CS: 'Condirettore di stabilimento',
  CSA: 'Capo servizio amministrativo',
  CSG: 'Custode sequestro giudiziario',
  CSS: 'Consigliere di sorveglianza supplente',
  CST: 'Commissario straordinario',
  CT: 'Condirettore tecnico',
  CTE: 'Consigliere e responsabile tecnico',
  CU: 'Capo ufficio',
  CUE: 'Curatore dello emancipato',
  CUF: 'Curatore fallimentare',
  CUM: 'Curatore speciale di minore',
  CUV: 'Capufficio vendite',
  CVE: 'Consiglio di sorveglianza',
  CZ: 'Condirettore di esercizio',
  DA: 'Direttore amministrativo',
  DAM: 'Dirigente amministrativo',
  DC: 'Direttore centrale',
  DCO: 'Dirigente commerciale',
  DCP: 'Dirigente con potere',
  DE: 'Direttore commerciale',
  DES: 'Delegato alla somministrazione',
  DF: 'Direttore di filiale',
  DFI: 'Direttore finanze',
  DG: 'Direttore generale',
  DI: 'Direttore interinale',
  DIA: 'Direttore artistico',
  DIP: 'Dipendente od altre forme contrattuali',
  DIR: 'Dirigente',
  DL2: 'Delegato di cui art. 2 legge 25/8/91 n.287',
  DLF: 'Delegato alla firma',
  DLR: 'Designato come rappresent. della soc. amministratrice',
  DMK: 'Direttore marketing',
  DNC: 'Dip. di impresa autoriz. al serv. noleg. con conducente',
  DP: 'Direttore del personale',
  DR: 'Direttore',
  DRE: 'Delegato iscrizione rec',
  DRG: 'Direttore regionale',
  DRR: 'Direttore responsabile',
  DS: 'Direttore di stabilimento',
  DSA: "Delegato di cui all'art. 2 della legge 287 del 25.8.1991",
  DT: 'Direttore tecnico',
  DTD: 'Delegato al ritiro capitale versato',
  DZ: 'Direttore di esercizio',
  ELE: 'Elettore',
  ESP: 'Accettazione nomina esperto ex art. 18 dlgs 14/2019 e smi',
  EXS: 'Ex socio di società di persone',
  FAT: 'Fattore di campagna',
  FC: 'Familiare componente',
  FU: 'Funzionario',
  GE: "Gestore dell'esercizio",
  GER: 'Gerente',
  GID: 'Giudice delegato',
  GOV: 'Governatore',
  GSG: 'Gestore sequestro giudiziario',
  IG: 'Ispettore generale',
  IMN: 'Impresa mandante',
  IMR: 'Impresa mandataria',
  IN: 'Institore',
  IS: 'Ispettore',
  LER: 'Legale rappresentante',
  LGR: 'Legale rappresentante di società',
  LGT: 'Legale rappresentante intestatario del tesserino',
  LI: 'Liquidatore',
  LIG: 'Liquidatore giudiziario',
  LR2: 'Legale rappresentante art.2 l. 25/8/91 n.287',
  LRC: 'Legale rappresentante congiuntamente',
  LRD: 'Legale rappresentante disgiuntamente',
  LRF: 'Legale rappresentante / firmatario',
  LRL: 'Legale rappresentante con limitazioni',
  LRT: 'Legale rappresentante e responsabile tecnico',
  LSA: "Legale rappresentante di cui all'art. 2 della legge 287 del 25.8.1991",
  LUL: 'Liquidatore di unità locale',
  MA: 'Mandatario',
  MCA: 'Membro commiss. amministrativa',
  MCD: 'Membro comitato direttivo',
  MCE: 'Membro comitato esecutivo',
  MCG: 'Membro comitato di gestione',
  MCS: 'Membro comitato di sorveglianza',
  MCT: 'Membro del comitato strategico',
  MDC: 'Membro di comunione ereditaria',
  MED: 'Membro effettivo consiglio direttivo',
  MGD: 'Membro consiglio direttivo',
  MGE: 'Membro giunta esecutiva',
  MGS: 'Membro del comitato di controllo sulla gestione',
  MI: 'Minore rappresentato dal tutore',
  MPP: 'Madre esercente la patria potestà',
  MS: 'Mandato speciale',
  MSD: 'Membro supplente consiglio direttivo',
  NE: 'Non elettore',
  OAS: 'Accomandatario di sapa',
  OCA: "Consiglio d'amministrazione",
  OCO: 'Consiglio direttivo',
  ODI: 'Comitato direttivo',
  OES: 'Comitato esecutivo',
  OPA: 'Più amministratori',
  OPC: 'Persona operante per conto della società',
  OPN: 'Presidente di consorzio',
  PA: 'Procuratore amministrativo',
  PAD: 'Presidente e amministratore delegato',
  PAF: 'Persona autorizzata alla firma',
  PAR: 'Preposto agenti rappresentanti di commercio',
  PB: 'Procuratore di borsa',
  PC: 'Procuratore',
  PCA: 'Presidente consiglio amministrazione',
  PCD: 'Presidente comitato direttivo',
  PCE: 'Presidente comitato esecutivo',
  PCG: 'Presidente del comitato di gestione',
  PCM: 'Presidente commiss. amministrativa',
  PCO: 'Presidente consorzio',
  PCP: 'Procuratore con postilla',
  PCS: 'Presidente del collegio sindacale',
  PCT: 'Presidente del comitato di controllo sulla gestione',
  PCV: 'Presidente del consiglio di sorveglianza',
  PDC: 'Presidente e consigliere delegato',
  PDI: 'Rappresentante preposto alla dipendenza in italia',
  PDS: 'Procuratore di società con somministrazione',
  PE: 'Procuratore commerciale',
  PED: 'Presidente effettivo consiglio direttivo',
  PEO: 'Presidente e preposto',
  PEP: 'Persona preposta un dipend.',
  PES: 'Preposto esercizio',
  PF: 'Procuratore di filiale',
  PFT: 'Preposto alla gestione di reparto l. 4/8/2006 n.248',
  PG: 'Procuratore generale',
  PGC: 'Preposto al commercio settore alimentare',
  PGD: 'Presidente consiglio direttivo',
  PGE: 'Presidente giunta esecutiva',
  PGF: 'Preposto alla gestione tecnica (d.m. n.221/2003)',
  PGM: 'Preposto alla mediazione di cui art. 11 d.m. 452/90',
  PGS: 'Presidente del consiglio di gestione',
  PGT: 'Preposto alla gestione tecnica ai sensi del d.m. 274/97',
  PL: 'Procuratore centrale',
  PM: 'Padre o madre esercente la patria potestà',
  PN: 'Procuratore ad negotia',
  PP: 'Procuratore speciale',
  PPP: 'Padre esercente la patria potestà',
  PPR: 'Preside protempore',
  PR: 'Protutore',
  PRA: 'Presidente aggiunto',
  PRC: 'Presidente dei revisori legali',
  PRE: 'Presidente',
  PRO: 'Presidente onorario',
  PRP: 'Proprietario',
  PRQ: 'Proprietario autorizzato a riscuotere e quietanzare',
  PRS: 'Preposto',
  PRT: 'Procuratore responsabile tecnico settore spedizione',
  PS: 'Procuratore superiore',
  PSD: 'Presidente supplente consiglio direttivo',
  PSE: 'Rappresentante preposto a sede secondaria in italia',
  PSS: 'Preposto della sede secondaria',
  PT: 'Procuratore tecnico',
  PTE: 'Presidente e responsabile tecnico',
  PTR: "Preposto alla gestione tecnica ai sensi dell'art. 7, legge n.122 del 5/2/1992",
  PTS: 'Preposto alla gestione tecnica ai sensi d.m. 37/2008',
  PTT: 'Preposto alla gestione tecnica ai sensi l. 46/90',
  RA: 'Responsabile agli acquisti',
  RAF: "Rappresentante legale di cui all'art. 93 del r.d. 18/6/1931 n. 773",
  RAP: "Rappresentante legale di cui all'art. 93 del r.d. 18/6/1931 n. 773",
  RAS: 'Rappresentante stabile',
  RAZ: 'Rappresentante comune soci',
  RC: 'Revisore legale',
  RCF: 'Rappresentante comune patrimoni/finanziamenti',
  RCO: 'Rappresentante comune obbligazionisti',
  RCS: 'Revisore dei conti supplente',
  RDF: 'Responsabile di filiale',
  RE: 'Responsabile',
  RES: 'Rappresentante società estera',
  RFM: 'Legale rappresentante figlio minore',
  RG: 'Rappresentante alle grida',
  RIN: 'Legale rappresentante di incapace',
  RIT: 'Rappresentante in italia',
  RPS: 'Rappresentante legge p.s.',
  RSS: 'Rappresentante legale delle sedi secondarie',
  RSU: 'Revisore unico',
  RTA: 'Responsabile tecnico acconciatore',
  RTC: 'Responsabile tecnico',
  RTE: 'Responsabile tecnico estetista',
  RV: 'Responsabile alle vendite',
  SA: "Socio accomandatario d'opera",
  SAB: 'Socio abilitato',
  SAO: "Socio accomandatario d'opera",
  SAP: 'Socio accomandatario e preposto',
  SCA: 'Segretario del consiglio di amministrazione',
  SCR: 'Socio rappresentante',
  SDR: 'Società di revisione',
  SEP: 'Socio e preposto',
  SFC: 'Socio con firma congiunta',
  SFI: 'Socio finanziatore',
  SGE: 'Segretario generale',
  SIE: 'Sindaco',
  SIP: 'Sindaco protempore',
  SIS: 'Sindaco supplente',
  SLA: 'Socio lavorante',
  SLR: 'Socio e legale rappresentante',
  SNA: 'Socio non abilitato',
  SNC: 'Sost. dip. di impresa autoriz. al serv. noleg. con conducente',
  SNP: 'Socio che non partecipa alle lavorazioni',
  SNQ: 'Socio non qualificato',
  SOA: 'Socio amministratore',
  SOC: 'Socio accomandante',
  SOF: 'Socio di società di fatto',
  SOL: 'Socio accomandatario e rappresentante legale',
  SON: 'Socio di società in nome collettivo',
  SOP: 'Socio di opera',
  SOR: 'Socio accomandatario',
  SOS: 'Sostituto del titolare',
  SOT: 'Socio contitolare',
  SOU: 'Socio unico',
  SPR: 'Socio di società di persone rappres.',
  SQ: 'Sequestratario',
  SQU: 'Socio qualificato',
  STE: 'Socio e responsabile tecnico',
  SVR: 'Sovrintendente',
  TES: 'Tesoriere',
  TI: 'Titolare',
  TI2: 'Titolare di cui art. 2 legge 25/8/91 n.287',
  TIT: 'Titolare firmatario',
  TMI: 'Titolare marchio identificativo',
  TPS: 'Titolare di licenza p.s.',
  TTE: 'Titolare e responsabile tecnico',
  TU: 'Tutore',
  UM1: "Rappresentante legale di cui all'art. 2 legge reg. n. 37 del 30/8/1988",
  UM2: "Preposto di cui all'art. 2 legge re. n. 37 del 30/8/1988",
  US: 'Usufruttuario',
  VAD: 'Vice amministratore delegato',
  VCA: 'Vice amministratore',
  VCD: 'Vice consigliere delegato',
  VCG: 'Vice commissario governativo',
  VCO: 'Vice commissario straordinario',
  VDA: 'Vice direttore amministrativo',
  VDC: 'Vice direttore centrale',
  VDE: 'Vice direttore commerciale',
  VDF: 'Vice direttore di filiale',
  VDG: 'Vice direttore generale',
  VDI: 'Vice direttore interinale',
  VDS: 'Vice direttore di stabilimento',
  VDT: 'Vice direttore tecnico',
  VDZ: 'Vice direttore di esercizio',
  VED: 'Vicepresidente effettivo consiglio direttivo',
  VGD: 'Vicepresidente consiglio direttivo',
  VGE: 'Vice gerente',
  VGO: 'Vice governatore',
  VIC: 'Vice presidente',
  VID: 'Vice direttore',
  VIV: 'Vice presidente vicario',
  VPA: "Vice presidente del consiglio d'amministrazione",
  VPC: 'Vice presidente e consigliere delegato',
  VPE: 'Vice presid. giunta esecutiva',
  VPP: 'Vice presidente e preposto',
  VSD: 'Vicepresidente supplente consiglio direttivo',
  VSG: 'Vice segretario generale',
} as const;
export type OfficeCode = keyof typeof OFFICE_CODES;

export const isOfficeCode = (v: unknown): v is OfficeCode => typeof v === 'string' && Object.hasOwn(OFFICE_CODES, v);

/** Gli organi in cui si raccolgono le cariche, nell'ordine in cui si mostrano. */
export const OFFICE_BODIES = [
  'Soci',
  'Titolare',
  'Organo amministrativo',
  'Rappresentanza legale',
  'Direzione',
  'Procuratori e institori',
  'Organo di controllo',
  'Revisione legale',
  'Preposti e responsabili tecnici',
  'Liquidazione e procedure',
  'Altre cariche e qualifiche',
] as const;
export type OfficeBody = (typeof OFFICE_BODIES)[number];

const BODY_OF: Partial<Record<OfficeBody, readonly OfficeCode[]>> = {
  Soci: ['COM', 'SOU', 'SOA', 'SOR', 'SOC', 'SON', 'SOP', 'SA', 'SAO', 'SFI', 'CPR', 'US', 'RAZ', 'SCR', 'SLR', 'SOL', 'OAS', 'SPR', 'SOF', 'SOT', 'SEP', 'STE', 'SAP', 'SLA', 'ASO', 'SNP', 'SQU', 'SNQ', 'SAB', 'SNA', 'SFC', 'EXS'],
  Titolare: ['TI', 'TIT', 'ATI', 'TTE', 'TI2', 'SOS'],
  'Organo amministrativo': ['AUN', 'AUP', 'AMM', 'ACP', 'ACR', 'APR', 'ART', 'OPA', 'COA', 'OCA', 'PCA', 'VPA', 'PAD', 'PDC', 'VPC', 'AMD', 'ADP', 'COD', 'CDP', 'CDT', 'CON', 'CLR', 'CEP', 'CTE', 'CDG', 'VAD', 'VCD', 'VCA', 'SCA', 'COS', 'COO', 'PRE', 'VIC', 'VIV', 'PRA', 'OES', 'MCE', 'PCE', 'CGS', 'CGE', 'PGS', 'DLR'],
  'Rappresentanza legale': ['LER', 'LGR', 'LRC', 'LRD', 'LRF', 'LRL', 'LRT', 'RSS', 'PSE', 'PDI', 'RIT', 'RAS', 'RES', 'PSS'],
  Direzione: ['DG', 'VDG', 'CG', 'DC', 'VDC', 'CC', 'DA', 'VDA', 'CA', 'DE', 'VDE', 'CE', 'DT', 'VDT', 'CT', 'DFI', 'DP', 'DMK', 'DR', 'VID', 'CD', 'DIR', 'DAM', 'DCO', 'DCP'],
  'Procuratori e institori': ['PC', 'PG', 'PP', 'PN', 'PA', 'PE', 'PT', 'PF', 'PL', 'PS', 'PCP', 'PB', 'PDS', 'PRT', 'IN', 'DLF', 'PAF', 'MS', 'MA'],
  'Organo di controllo': ['SIE', 'SIS', 'PCS', 'CCG', 'MGS', 'PCT', 'CVE', 'CDS', 'CSS', 'PCV'],
  'Revisione legale': ['RC', 'RSU', 'SDR', 'PRC', 'RCS'],
  'Preposti e responsabili tecnici': ['PRS', 'RTC', 'PGT', 'PTS', 'PTT', 'PTR', 'PGF', 'PGM', 'PGC', 'PFT', 'PES', 'PEP', 'PAR', 'RTA', 'RTE', 'PEO', 'PTE'],
  'Liquidazione e procedure': ['LI', 'LIG', 'LUL', 'COL', 'COG', 'COZ', 'CUF', 'CRT', 'AMG', 'AMS', 'AMP', 'CMS', 'CST', 'COV', 'COP', 'CM', 'GID', 'CSG', 'GSG', 'SQ', 'ALR', 'ESP'],
};
const BODY = new Map<OfficeCode, OfficeBody>(Object.entries(BODY_OF).flatMap(([b, codes]) => codes.map((c) => [c, b as OfficeBody] as const)));

/** L'organo della carica (le cariche senza un organo del codice civile stanno in «Altre cariche e qualifiche»). */
export const officeBody = (code: OfficeCode): OfficeBody => BODY.get(code) ?? 'Altre cariche e qualifiche';

/** Le cariche che dicono solo chi rappresenta l'impresa: con una carica dell'organo amministrativo sono la stessa cosa. */
export const REPRESENTATIVE_CODES: readonly OfficeCode[] = ['LER', 'LGR', 'LRF'];

const plain = (s: string) =>
  s
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
const BY_NAME = new Map<string, OfficeCode>();
for (const [code, name] of Object.entries(OFFICE_CODES) as Array<[OfficeCode, string]>) if (!BY_NAME.has(plain(name))) BY_NAME.set(plain(name), code);

/**
 * Il codice di una carica scritta esattamente come nella codifica (maiuscole, accenti, punteggiatura e femminile non
 * contano), o null.
 */
export function officeCodeByName(written: string | null | undefined): OfficeCode | null {
  const p = masculine(plain(written ?? '').replace(/^nomina a(d)? /, ''));
  return BY_NAME.get(p) ?? null;
}

const FEMININE: Record<string, string> = { consigliera: 'consigliere', presidentessa: 'presidente', socia: 'socio', sindaca: 'sindaco', unica: 'unico', delegata: 'delegato' };
/** La tabella scrive le cariche al maschile: «procuratrice», «amministratrice», «consigliera» sono le stesse. */
const masculine = (p: string) =>
  p
    .split(' ')
    .map((w) => (w.endsWith('trice') ? `${w.slice(0, -5)}tore` : (FEMININE[w] ?? w)))
    .join(' ');
